import { userManagementActions } from "../../constants/actionTypes";

const userManagementUploadRequestAction = (data) => ({
  type: userManagementActions.userManagementUploadRequest,
  data: data,
});

const userManagementUploadSuccessAction = (data) => ({
  type: userManagementActions.userManagementUploadSuccess,
  data: data,
});

const userManagementUploadErrorAction = (data) => ({
  type: userManagementActions.userManagementUploadError,
  data: data,
});

const getUserListData = (data) => ({
  type: userManagementActions.userListGetData,
  payload: data,
});

const getAllUserListData = (data) => ({
  type: userManagementActions.allUserListGetData,
  payload: data,
});

const getUserListDataPaginated = (data) => ({
  type: userManagementActions.userListGetDataPaginated,
  payload: data,
});

const setUserListData = (data) => ({
  type: userManagementActions.userListSetData,
  payload: data,
});

const setAllUserListData = (data) => ({
  type: userManagementActions.allUserListSetData,
  payload: data,
});

const setUserListDataPaginated = (data) => ({
  type: userManagementActions.userListSetDataPaginated,
  payload: data,
});

const resetUserListDataPaginated = (data) => ({
  type: userManagementActions.userListResetDataPaginated,
  payload: data,
});

const setUserListLoading = (data) => ({
  type: userManagementActions.userListSetLoading,
  payload: data,
});

const setUserListError = (data) => ({
  type: userManagementActions.userListSetError,
  payload: data,
});

const setAllUserListError = (data) => ({
  type: userManagementActions.allUserListSetError,
  payload: data,
});

const userManagementCreateUserRequestAction = (data) => ({
  type: userManagementActions.userManagementCreateUserRequest,
  data: data,
});

const userManagementCreateUserSuccessAction = (data) => ({
  type: userManagementActions.userManagementCreateUserSuccess,
  data: data,
});

const errorCreateUser = (data) => ({
  type: userManagementActions.ERROR_CREATE_USER,
  data: data,
});

const defaultRolesRequest = (data) => ({
  type: userManagementActions.defaultRolesRequest,
  data: data,
});

const defaultRolesSuccess = (data) => ({
  type: userManagementActions.defaultRolesSuccess,
  data: data,
});

const assignRolesRequest = (data) => ({
  type: userManagementActions.assignRolesRequest,
  data: data,
});

const assignRolesSuccess = (data) => ({
  type: userManagementActions.assignRolesSuccess,
  data: data,
});

const businessUnitRequest = (data) => ({
  type: userManagementActions.bussinessUnitRequest,
  data: data,
});

const businessUnitSuccess = (data) => ({
  type: userManagementActions.businessUnitSuccess,
  data: data,
});

const userManagementDeleteUser = (data) => ({
  type: userManagementActions.userManagementDeleteUser,
  data: data,
});

const userActionDataSuccess = (data) => ({
  type: userManagementActions.userActionDataSuccess,
  data: data,
});

const suspendUser = (id, data) => ({
  type: userManagementActions.suspendUser,
  data: { id, data },
});

const userManagementEditUserRequestAction = (data) => ({
  type: userManagementActions.userManagementEditUserRequest,
  data: data,
});

const userManagementEditUserSuccessAction = (data) => ({
  type: userManagementActions.userManagementEditUserSuccess,
  data: data,
});

const userManagementEditUserErrorAction = (data) => ({
  type: userManagementActions.userManagementEditUserError,
  data: data,
});

const userManagementUpdateUserRequestAction = (data, id) => ({
  type: userManagementActions.userManagementUpdateUserRequest,
  data: data,
  id: id,
});

const userManagementUpdateUserSuccessAction = (data) => ({
  type: userManagementActions.userManagementUpdateUserSuccess,
  data: data,
});

const userManagementUpdateUserErrorAction = (data) => ({
  type: userManagementActions.userManagementUpdateUserError,
  data: data,
});

const userManagementDeleteUserSuccessAction = (data) => ({
  type: userManagementActions.USER_MNGMNT_DELETE_USER_SUCCESS,
  data: data,
});

const retrieveUserDetails = (data) => ({
  type: userManagementActions.retrieveUserDetail,
  payload: data,
});

const setUserInfo = (data) => ({
  type: userManagementActions.setUserDetail,
  payload: data,
});

const removeSelectedUserDetails = () => ({
  type: userManagementActions.REMOVE_SELECTED_USER_DETAILS,
});

const activeUserDownloadLoading = (payload) => ({
  type: userManagementActions.ACTIVE_USER_DOWNLOAD_LOADING,
  payload: payload,
});
const activeUserDownloadAction = (payload) => ({
  type: userManagementActions.ACTIVE_USER_DOWNLOAD_ACTION,
  payload: payload,
});
const activeUserDownloadSuccess = (payload) => ({
  type: userManagementActions.ACTIVE_USER_DOWNLOAD_SUCCESS,
  payload: payload,
});
const activeUserDownloadError = (payload) => ({
  type: userManagementActions.ACTIVE_USER_DOWNLOAD_ERROR,
  payload: payload,
});
const activeUserDownloadReset = () => ({
  type: userManagementActions.ACTIVE_USER_DOWNLOAD_RESET,
});

export {
  userManagementUploadRequestAction,
  userManagementUploadSuccessAction,
  getUserListData,
  setUserListData,
  setUserListError,
  userManagementCreateUserRequestAction,
  userManagementCreateUserSuccessAction,
  defaultRolesRequest,
  defaultRolesSuccess,
  assignRolesRequest,
  assignRolesSuccess,
  businessUnitRequest,
  businessUnitSuccess,
  userManagementEditUserRequestAction,
  userManagementEditUserSuccessAction,
  userManagementUpdateUserRequestAction,
  userManagementUpdateUserSuccessAction,
  userActionDataSuccess,
  userManagementDeleteUser,
  suspendUser,
  userManagementDeleteUserSuccessAction,
  retrieveUserDetails,
  setUserInfo,
  removeSelectedUserDetails,
  errorCreateUser,
  userManagementEditUserErrorAction,
  userManagementUpdateUserErrorAction,
  setUserListLoading,
  getUserListDataPaginated,
  setUserListDataPaginated,
  resetUserListDataPaginated,
  userManagementUploadErrorAction,
  getAllUserListData,
  setAllUserListData,
  setAllUserListError,
  activeUserDownloadLoading,
  activeUserDownloadAction,
  activeUserDownloadSuccess,
  activeUserDownloadError,
  activeUserDownloadReset,
};
